import o from"./index.module.scss.js";const s=o;export{s as IconPopoverTheme};
//# sourceMappingURL=index.js.map
